import { Input } from '@chakra-ui/react'
import React, { forwardRef } from 'react'

import { SearchInputProps } from './types'

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onChange, placeholder, width }, ref) => {
    return (
      <Input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        width={width}
      />
    )
  }
)

SearchInput.displayName = 'SearchInput'
